module.exports = __webpack_public_path__ + "resources/img/title_arrow.95616995b5980fb702e4699cde8ce290.png";